// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* assets/css/MiniCalendar.css */
/* LIGHT MODE */
.past-period-date {
  color: #5158FF !important;
  background-color: #f4f7fe !important;
}

.past-period-date-start {
  background-color: #5158FF !important;
  color: white !important;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.past-period-date-end {
  background-color: #5158FF !important;
  color: white !important;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.react-calendar {
  border: unset;
  background-color: transparent;
  font-family: "DM Sans", sans-serif;
}
.react-calendar__navigation__prev2-button {
  display: none;
}
.react-calendar__navigation__next2-button {
  display: none;
}
.react-calendar__navigation {
  align-items: center;
}
abbr[title] {
  border-bottom: none;
  -webkit-text-decoration: unset;
  text-decoration: unset;
  -webkit-text-decoration: unset;
  -webkit-text-decoration: unset;
  text-decoration: unset !important;
}

.react-calendar__navigation__prev-button {
  background-color: #5158FF !important;
  border-radius: 10px;
  min-width: 34px !important;
  height: 34px !important;
  color: white;
}
.react-calendar__navigation__next-button {
  background-color: #5158FF !important;
  border-radius: 10px;
  min-width: 34px !important;
  width: 34px !important;
  height: 34px !important;
  color: white;
}
.react-calendar__navigation__label {
  font-weight: 700 !important;
  font-size: 18px;
}
.react-calendar__navigation__label:hover,
.react-calendar__navigation__label:focus {
  background-color: unset !important;
  border-radius: 10px;
}
.react-calendar__tile {
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px !important;
  height: 34px !important;
  color: #1b2559;
}
.react-calendar__month-view__weekdays {
  background-color: #f4f7fe;
  border-radius: 10px;
  margin-bottom: 6px;
  font-size: 10px;
}
.react-calendar__tile--now,
.react-calendar__tile--now:enabled:hover,
.react-calendar__tile--now:enabled:focus {
  background-color: #f4f7fe;
  border-radius: 10px;
}
.react-calendar__month-view__days__day--neighboringMonth {
  color: #b0bbd5;
}
.react-calendar__tile--active,
.react-calendar__tile--active:enabled:hover,
.react-calendar__tile--active:enabled:focus {
  background: #00E5D1;
  border-radius: 10px;
  color: white;
}
.react-calendar__tile--range,
.react-calendar__tile--range:enabled:hover,
.react-calendar__tile--range:enabled:focus {
  background: #f4f7fe;
  color: #00E5D1;
  border-radius: 0px;
}
.react-calendar--selectRange .react-calendar__tile--hover {
  background: #f4f7fe;
  color: #00E5D1;
}
.react-calendar__tile--rangeStart,
.react-calendar__tile--rangeStart:enabled:hover,
.react-calendar__tile--rangeStart:enabled:focus {
  background: #00E5D1;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  color: black;
}
.react-calendar__tile--rangeEnd,
.react-calendar__tile--rangeEnd:enabled:hover,
.react-calendar__tile--rangeEnd:enabled:focus {
  background: #00E5D1;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  color: black;
}

/* DARK MODE */
.past-period-date-start-dark {
  background-color: #5158FF;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.past-period-date-end-dark {
  background-color: #5158FF;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.past-period-date-dark {
  color: #5158FF !important;
  background-color: rgba(255, 255, 255, 0.1);
}

body.chakra-ui-dark .react-calendar {
  border-radius: 20px;
}
body.chakra-ui-dark .react-calendar__navigation__prev-button {
  background-color: #5158FF !important;
}
body.chakra-ui-dark .react-calendar__navigation__next-button {
  background-color: #5158FF !important;
  color: white;
}
body.chakra-ui-dark .react-calendar__tile {
  color: white;
}
body.chakra-ui-dark .react-calendar__tile:enabled:hover,
body.chakra-ui-dark .react-calendar__tile:enabled:focus {
  background-color: rgba(255, 255, 255, 0.1);
}
body.chakra-ui-dark .react-calendar__month-view__weekdays {
  background-color: rgba(255, 255, 255, 0.1);
}
body.chakra-ui-dark .react-calendar__tile--now,
body.chakra-ui-dark .react-calendar__tile--now:enabled:hover,
body.chakra-ui-dark .react-calendar__tile--now:enabled:focus {
  background-color: rgba(255, 255, 255, 0.1);
}
body.chakra-ui-dark .react-calendar__month-view__days__day--neighboringMonth {
  color: #b0bbd5;
}
body.chakra-ui-dark .react-calendar__tile--active,
body.chakra-ui-dark .react-calendar__tile--active:enabled:hover,
body.chakra-ui-dark .react-calendar__tile--active:enabled:focus {
  background: #00E5D1;
  color: white;
}
body.chakra-ui-dark .react-calendar__tile--range,
body.chakra-ui-dark .react-calendar__tile--range:enabled:hover,
body.chakra-ui-dark .react-calendar__tile--range:enabled:focus {
  background: rgba(255, 255, 255, 0.1);
  color: #00E5D1;
}

body.chakra-ui-dark .react-calendar--selectRange .react-calendar__tile--hover {
  background: rgba(255, 255, 255, 0.1);
  color: #00E5D1;
}

body.chakra-ui-dark .react-calendar__tile--rangeStart,
body.chakra-ui-dark .react-calendar__tile--rangeStart:enabled:hover,
body.chakra-ui-dark .react-calendar__tile--rangeStart:enabled:focus {
  background: #00E5D1;
  color: black;
}
body.chakra-ui-dark .react-calendar__tile--rangeEnd,
body.chakra-ui-dark .react-calendar__tile--rangeEnd:enabled:hover,
body.chakra-ui-dark .react-calendar__tile--rangeEnd:enabled:focus {
  background: #00E5D1;
  color: black;
}

.not-selected-mode {
  background-color: rgba(0, 0, 0, 0.3) !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/MiniCalendar.css"],"names":[],"mappings":"AAEA,gCAAgC;AAChC,eAAe;AACf;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,kCAAkC;AACpC;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,eAAe;AACjB;AACA;;EAEE,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;;;EAGE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;AACA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;;;EAGE,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;EAC/B,YAAY;AACd;AACA;;;EAGE,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,YAAY;AACd;;AAEA,cAAc;AACd;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;;EAEE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;;;EAGE,0CAA0C;AAC5C;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,mBAAmB;EACnB,YAAY;AACd;AACA;;;EAGE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,YAAY;AACd;AACA;;;EAGE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap\");\n\n/* assets/css/MiniCalendar.css */\n/* LIGHT MODE */\n.past-period-date {\n  color: #5158FF !important;\n  background-color: #f4f7fe !important;\n}\n\n.past-period-date-start {\n  background-color: #5158FF !important;\n  color: white !important;\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n}\n\n.past-period-date-end {\n  background-color: #5158FF !important;\n  color: white !important;\n  border-top-right-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n\n.react-calendar {\n  border: unset;\n  background-color: transparent;\n  font-family: \"DM Sans\", sans-serif;\n}\n.react-calendar__navigation__prev2-button {\n  display: none;\n}\n.react-calendar__navigation__next2-button {\n  display: none;\n}\n.react-calendar__navigation {\n  align-items: center;\n}\nabbr[title] {\n  border-bottom: none;\n  -webkit-text-decoration: unset;\n  text-decoration: unset;\n  -webkit-text-decoration: unset;\n  -webkit-text-decoration: unset;\n  text-decoration: unset !important;\n}\n\n.react-calendar__navigation__prev-button {\n  background-color: #5158FF !important;\n  border-radius: 10px;\n  min-width: 34px !important;\n  height: 34px !important;\n  color: white;\n}\n.react-calendar__navigation__next-button {\n  background-color: #5158FF !important;\n  border-radius: 10px;\n  min-width: 34px !important;\n  width: 34px !important;\n  height: 34px !important;\n  color: white;\n}\n.react-calendar__navigation__label {\n  font-weight: 700 !important;\n  font-size: 18px;\n}\n.react-calendar__navigation__label:hover,\n.react-calendar__navigation__label:focus {\n  background-color: unset !important;\n  border-radius: 10px;\n}\n.react-calendar__tile {\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px !important;\n  height: 34px !important;\n  color: #1b2559;\n}\n.react-calendar__month-view__weekdays {\n  background-color: #f4f7fe;\n  border-radius: 10px;\n  margin-bottom: 6px;\n  font-size: 10px;\n}\n.react-calendar__tile--now,\n.react-calendar__tile--now:enabled:hover,\n.react-calendar__tile--now:enabled:focus {\n  background-color: #f4f7fe;\n  border-radius: 10px;\n}\n.react-calendar__month-view__days__day--neighboringMonth {\n  color: #b0bbd5;\n}\n.react-calendar__tile--active,\n.react-calendar__tile--active:enabled:hover,\n.react-calendar__tile--active:enabled:focus {\n  background: #00E5D1;\n  border-radius: 10px;\n  color: white;\n}\n.react-calendar__tile--range,\n.react-calendar__tile--range:enabled:hover,\n.react-calendar__tile--range:enabled:focus {\n  background: #f4f7fe;\n  color: #00E5D1;\n  border-radius: 0px;\n}\n.react-calendar--selectRange .react-calendar__tile--hover {\n  background: #f4f7fe;\n  color: #00E5D1;\n}\n.react-calendar__tile--rangeStart,\n.react-calendar__tile--rangeStart:enabled:hover,\n.react-calendar__tile--rangeStart:enabled:focus {\n  background: #00E5D1;\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n  color: black;\n}\n.react-calendar__tile--rangeEnd,\n.react-calendar__tile--rangeEnd:enabled:hover,\n.react-calendar__tile--rangeEnd:enabled:focus {\n  background: #00E5D1;\n  border-top-right-radius: 10px;\n  border-bottom-right-radius: 10px;\n  color: black;\n}\n\n/* DARK MODE */\n.past-period-date-start-dark {\n  background-color: #5158FF;\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n}\n\n.past-period-date-end-dark {\n  background-color: #5158FF;\n  border-top-right-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n\n.past-period-date-dark {\n  color: #5158FF !important;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\nbody.chakra-ui-dark .react-calendar {\n  border-radius: 20px;\n}\nbody.chakra-ui-dark .react-calendar__navigation__prev-button {\n  background-color: #5158FF !important;\n}\nbody.chakra-ui-dark .react-calendar__navigation__next-button {\n  background-color: #5158FF !important;\n  color: white;\n}\nbody.chakra-ui-dark .react-calendar__tile {\n  color: white;\n}\nbody.chakra-ui-dark .react-calendar__tile:enabled:hover,\nbody.chakra-ui-dark .react-calendar__tile:enabled:focus {\n  background-color: rgba(255, 255, 255, 0.1);\n}\nbody.chakra-ui-dark .react-calendar__month-view__weekdays {\n  background-color: rgba(255, 255, 255, 0.1);\n}\nbody.chakra-ui-dark .react-calendar__tile--now,\nbody.chakra-ui-dark .react-calendar__tile--now:enabled:hover,\nbody.chakra-ui-dark .react-calendar__tile--now:enabled:focus {\n  background-color: rgba(255, 255, 255, 0.1);\n}\nbody.chakra-ui-dark .react-calendar__month-view__days__day--neighboringMonth {\n  color: #b0bbd5;\n}\nbody.chakra-ui-dark .react-calendar__tile--active,\nbody.chakra-ui-dark .react-calendar__tile--active:enabled:hover,\nbody.chakra-ui-dark .react-calendar__tile--active:enabled:focus {\n  background: #00E5D1;\n  color: white;\n}\nbody.chakra-ui-dark .react-calendar__tile--range,\nbody.chakra-ui-dark .react-calendar__tile--range:enabled:hover,\nbody.chakra-ui-dark .react-calendar__tile--range:enabled:focus {\n  background: rgba(255, 255, 255, 0.1);\n  color: #00E5D1;\n}\n\nbody.chakra-ui-dark .react-calendar--selectRange .react-calendar__tile--hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #00E5D1;\n}\n\nbody.chakra-ui-dark .react-calendar__tile--rangeStart,\nbody.chakra-ui-dark .react-calendar__tile--rangeStart:enabled:hover,\nbody.chakra-ui-dark .react-calendar__tile--rangeStart:enabled:focus {\n  background: #00E5D1;\n  color: black;\n}\nbody.chakra-ui-dark .react-calendar__tile--rangeEnd,\nbody.chakra-ui-dark .react-calendar__tile--rangeEnd:enabled:hover,\nbody.chakra-ui-dark .react-calendar__tile--rangeEnd:enabled:focus {\n  background: #00E5D1;\n  color: black;\n}\n\n.not-selected-mode {\n  background-color: rgba(0, 0, 0, 0.3) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
